import SideMenu from '@/containers/side-menu/SideMenu.vue';
import Vehicle from '@/pages/vehicle/Vehicle.vue';

export default {
  path: '/vehicles',
  name: 'Vehicles',
  components: {
    mainContent: Vehicle,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'vehicles',
    },
    breadcrumb: {
      title: 'Veículos',
      paths: [],
    },
  },
};
